<template>
	<div>
		<Top></Top>
		<div class="wd-container wd-m-t-20">
			<div class="loginhint" v-if="!logininfo.islogin">
				<i class="wd-icon">&#xe7a1;</i>
				<span class="wd-m-l-10">您还没有登录，登录后购物车的商品将保存在您的账号中！</span>
			</div>
			<div class="cartlist">
				<div v-if="cartlist.length === 0">
					<div class="empty wd-flex wd-row-center wd-col-center"><el-image src="../img/cartempty.png" class="emptyimg"></el-image></div>
					<div class="wd-m-t-10 wd-text-center">购物车内暂时没有商品</div>
				</div>
				<div v-else>
					<div class="wd-m-t-10 wd-m-b-10">全部商品数（{{cartnum}}）</div>
					<div class="title wd-flex wd-row-between">
						<div class="check"><el-checkbox>全选</el-checkbox></div>
						<div class="goodsname wd-row-grow">商品</div>
						<div class="price">单价</div>
						<div class="num">数量</div>
						<div class="amount">小计</div>
						<div class="opt">操作</div>
					</div>
					<el-divider></el-divider>
					<div class="detail cart">
						<div  v-for="(mjitem,mjindex) in cartlist" :key="mjindex">
							<div class="manjiancss"  v-if="mjitem.manjianid!=''">
								<span class="flag">满减</span>
								<span class="wd-m-l-10 wdfont" v-if="mjitem.freeamount==0">{{mjitem.manjianname}}</span>
								<span class="wd-m-l-10 wdfont" v-if="mjitem.manjianlimituse==0 && mjitem.freeamount>0">金额已满{{mjitem.limitamount}}立减¥{{mjitem.freeamount}}</span>
								<span class="wd-m-l-10 wdfont" v-if="mjitem.manjianlimituse==1 && mjitem.freeamount>0">数量已满{{mjitem.limitamount}}立减¥{{mjitem.freeamount}}</span>
								<div v-if="mjitem.manjianindex!=''" class="wd-m-tb-5">
									<div v-for="(mditem,mdindex) in mjitem.manjiandetail[mjitem.manjianindex].detail" :key="mdindex" class="row wd-font-12">
										赠：<span class="wd-text-line1">{{mditem.goodsname}}</span><span>×{{mditem.num}}</span>
									</div>
								</div>
							</div>
							<div class="goods  wd-flex wd-row-between" v-for="(item, index) in mjitem.detail" :key="index">
								<div class="check2" @click="oneselect(mjindex,index)">
									<i class="wd-icon wd-font-26 wd-theme" v-if="item.checkstate==0">&#xe61e;</i>
									<i class="wd-icon wd-font-26 wd-theme" v-else>&#xe60a;</i>
								</div>
								<div class="goodsname wd-row-grow wd-flex wd-row-between">
									<div class="img"><el-image class="goodsimg" :src="$wdpicurl(item.pic1)"></el-image></div>
									<div class="wd-row-grow">
										<div class="name wd-line-2 ">
											<span>{{ item.name }}</span>
											<span v-if="item.color!=''" class="wd-theme-999 wd-m-l-5">{{ item.color }}</span>
											<span v-if="item.size!=''" class="wd-theme-999 wd-m-l-5">|{{ item.size }}</span>
										</div>
										<div class="wd-m-l-10 wd-m-t-10" v-if="item.yingxiaolist!=''">
											<el-select v-model="mjitem.manjianid" placeholder="换促销" size="mini" @change="((e)=>{yingxiaoselect(mjindex,index,e)})">
												<el-option
													v-for="(yxitem,yxindex) in item.yingxiaolist" :key="yxindex"
													:label="yxitem.memo"
													:value="yxitem.id">
												</el-option>
											</el-select>
										</div>
									</div>
								</div>
								<div class="" v-if="item.skdetailid!=0">
									<span class="wd-theme">¥{{ item.appprice|amountFormatter }}</span>
								</div>
								<div class="" v-else-if="item.appprice!=item.price1">
									<span class="wd-theme">¥{{ item.price1|amountFormatter }}</span>
									<span class="wd-theme-000 wd-m-l-10 wd-font-12 wd-font-bold">¥{{item.appprice|amountFormatter}}</span>
									<span class="pluscss" >PLUS</span>
								</div>
								<div v-else>
									<span class="wd-theme">¥{{ item.appprice|amountFormatter }}</span>
								</div>
								<div class="num"><el-input-number size="mini" :max="100" :min="1" v-model="item.num"></el-input-number></div>
								<div class="amount">¥{{ item.realamount|amountFormatter }}</div>
								<div class="opt">
									<p>
									<el-link @click="deletefromcart(mjindex,index,item.id)">删除</el-link>
									</p>
									<p>
									<el-link @click="favopt(mjindex,index,item.goodsid)">移到我的收藏夹</el-link>
									</p>
								</div>
							</div>
						</div>
					</div>
					<div class="wd-flex wd-row-between wd-m-t-10 wd-m-b-10">
						<div class="wd-flex wd-row-between">
							<el-checkbox>全选</el-checkbox>
							<div class="wd-m-l-20 wd-m-r-20">
								<el-link @click="deleteselect">删除选中的商品</el-link>
							</div>
							<div>
								<el-link>移到我的收藏</el-link>
							</div>
						</div>
						<div class="wd-flex wd-row-between">
							<div>
								已选择<span class="wd-theme wd-font-bold">{{checknum}}</span>件商品
							</div>
							<div class="wd-m-l-20 wd-m-r-20">
								<div>
									总价：<span class="wd-font-18 wd-font-bold wd-theme">¥{{selectamount|amountFormatter}}</span>
								</div>
								<div>
									已节省：-¥{{manjianamount|amountFormatter}}
								</div>
							</div>
							<div>
								<el-button type="primary" @click="gotobuy">去结算</el-button>
							</div>
						</div>
					</div>
					<el-divider></el-divider>
				</div>
			</div>
			<div>
				<el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
					<el-menu-item index="1">猜你喜欢</el-menu-item>
					<el-menu-item index="2">我的收藏</el-menu-item>
					<el-menu-item index="3">最近浏览</el-menu-item>
				</el-menu>
			</div>
			<div class="suggest" v-if="activeIndex === '1'">
				<div class="ul wd-flex wd-row-left">
					<div class="li" v-for="(item, index) in temphotlist" :key="index">
						<div class="goods" @click="gotogoodsdetail(item.goodsid,item.goodsname)">
							<div class="img"><el-image :src="$wdpicurl(item.pic1)" class="goodsimg"></el-image></div>
							<div class="name">{{ item.goodsname }}</div>
							<div class="price wd-theme">￥{{ item.retailprice|amountFormatter }}</div>
						</div>
					</div>
				</div>
				<div class="nav left" @click="suggestpage(-1)"><i class="wd-icon">&#xe7dd;</i></div>
				<div class="nav right" @click="suggestpage(1)"><i class="wd-icon">&#xe606;</i></div>
			</div>
			<div class="suggest" v-else-if="activeIndex === '2'">
				<div class="ul wd-flex wd-row-left">
					<div class="li" v-for="(item, index) in tempfavlist" :key="index">
						<div class="goods" @click="gotogoodsdetail(item.goodsid,item.goodsname)">
							<div class="img"><el-image :src="$wdpicurl(item.pic1)" class="goodsimg"></el-image></div>
							<div class="name">{{ item.goodsname }}</div>
							<div class="price wd-theme">￥{{ item.retailprice|amountFormatter }}</div>
						</div>
					</div>
				</div>
				<div class="nav left" @click="favpage(-1)"><i class="wd-icon">&#xe7dd;</i></div>
				<div class="nav right" @click="favpage(1)"><i class="wd-icon">&#xe606;</i></div>
			</div>
			<div class="suggest" v-else-if="activeIndex === '3'">
				<div class="ul wd-flex wd-row-left">
					<div class="li" v-for="(item, index) in temphistorylist" :key="index">
						<div class="goods" @click="gotogoodsdetail(item.goodsid,item.goodsname)">
							<div class="img"><el-image :src="$wdpicurl(item.pic1)" class="goodsimg"></el-image></div>
							<div class="name">{{ item.goodsname }}</div>
							<div class="price wd-theme">￥{{ item.retailprice|amountFormatter }}</div>
						</div>
					</div>
				</div>
				<div class="nav left" @click="historypage(-1)"><i class="wd-icon">&#xe7dd;</i></div>
				<div class="nav right" @click="historypage(1)"><i class="wd-icon">&#xe606;</i></div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import{mapState} from "vuex" 
import Top from '@/components/layout/Top.vue';
import Footer from '@/components/layout/Footer.vue';
export default {
	name: 'Cart',
	computed:{...mapState(['logininfo'])},
	components: {
		Top,
		Footer
	},
	data() {
		return {
			hotlist: [],
			temphotlist: [],
			pageindex: 0,
			activeIndex: '1',
			cartlist: [],
			cartnum:0,
			historylist:[],
			temphistorylist:[],
			historypageindex: 0,
			favlist:[],
			tempfavlist:[],
			favpageindex: 0,
			selectamount:0,
			checknum:0,
			selectnum:0,
			manjianamount:0
		};
	},
	methods: {
		resort(data){
			var rs = []
			var i = 0
			var j = 0
			for (i = 0; i < data.length; i++) {
				let manjianid=data[i].manjianid||""
				if (data[i].yingxiaolist!=''){
					let idx=-1;
					if (manjianid!==""){
						idx=data[i].yingxiaolist.findIndex((item)=>(item.id===manjianid));
					}
					if (idx===-1){
						idx=0;
					}
					data[i].yingxiaolist[idx].checkstate=0;
					data[i].manjianid=data[i].yingxiaolist[idx].id;
					data[i].manjianname=data[i].yingxiaolist[idx].name;
					data[i].manjianlimituse=data[i].yingxiaolist[idx].limituse;
					data[i].manjianindex="";
					data[i].manjianflag=data[i].yingxiaolist[idx].flag;
					data[i].manjiandetail=data[i].yingxiaolist[idx].detail;
				}else{
					data[i].manjianid="";
					data[i].manjianname="";
					data[i].manjianlimituse="";
					data[i].manjiandetail="";
					data[i].manjianflag="";
					data[i].manjianindex="";
				}
			}
			for (i = 0; i < data.length; i++) {
				let manjianitem=data[i]
				let manjianid= manjianitem.manjianid||""
				let idx=-1;
				if (rs.length>0){
					idx=rs.findIndex((item)=>(item.manjianid===manjianid));
				}
				if (idx===-1){
					rs.push({
						manjianid:manjianid,
						manjianname:manjianitem.manjianname,
						manjianlimituse:manjianitem.manjianlimituse,
						manjianflag:manjianitem.manjianflag,
						manjiandetail:manjianitem.manjiandetail,
						manjianindex:"",
						detail:[]
					})
				}
			}
			for (i = 0; i < rs.length; i++) {
				for (j = 0; j < data.length; j++) {
					if (rs[i].manjianid===data[j].manjianid){
						rs[i].detail.push(data[j])
					}
				}
			}
			this.cartlist=rs;
			this.checkstateflag();
			this.calc_manjian();
		},
		calc_manjian(){
			//计算满减
			var manjianamount=0;
			// var realamount=0;
			let aamount=0,anum=0;
			// let acnt=0;
			var detail_sort=[];
			for (let mjindex in this.cartlist){
				
				let manjianitem=this.cartlist[mjindex];
				let camount=0;
				let cnum=0;
				// let jamount=0;
				// let jnum=0;
				for (let index in manjianitem.detail) {
					let item=manjianitem.detail[index];
					if (item.checkstate==0){
						camount=camount+parseFloat(item.realamount);
						cnum=cnum+parseInt(item.num);
						aamount=aamount+parseFloat(item.realamount);
						anum=anum+parseInt(item.num);
						for (var k = 0; k < item.num; k++) {
							detail_sort.push(parseFloat(item.appprice));
						}
						// acnt++;
					}
				}
				detail_sort.sort(function(a,b){
					return a<b?1:-1
				})
				if (manjianitem.manjianid||""!==""){
					if (manjianitem.manjianlimituse==0){//金额满减送
						let limitamount=0;
						let freeamount=0;
						let manjianindex=0;
						for(let j in manjianitem.manjiandetail){
							if (camount>=parseFloat(manjianitem.manjiandetail[j].limitamount)){
								limitamount=parseFloat(manjianitem.manjiandetail[j].limitamount);
								freeamount=parseFloat(manjianitem.manjiandetail[j].freeamount);
								manjianindex=j;
							}
						}
						manjianitem.freeamount=freeamount;
						manjianitem.limitamount=limitamount;
						manjianitem.manjianindex=manjianindex;
						manjianamount=manjianamount+freeamount;
					}else if (manjianitem.manjianlimituse==1){//数量满减送
						let limitamount=0;
						let freeamount=0;
						let manjianindex=0;
						let cha=detail_sort.length-manjianitem.manjiandetail.length;
						if (cha<0){
							cha=0;
						}
						for(let j in manjianitem.manjiandetail){
							if (manjianitem.manjianflag=='1'){//满减
								if (cnum>=parseFloat(manjianitem.manjiandetail[j].limitamount)){
									limitamount=parseFloat(manjianitem.manjiandetail[j].limitamount);
									freeamount=parseFloat(manjianitem.manjiandetail[j].freeamount);
									manjianindex=j;
								}
							}else if (manjianitem.manjianflag=='3'){//阶梯
									let chavalue=parseInt(j)+parseInt(cha);
									if (detail_sort.length>chavalue){
										if (cnum>=parseFloat(manjianitem.manjiandetail[j].limitamount)){
											limitamount=parseFloat(manjianitem.manjiandetail[j].limitamount);
											let tmp_amount=0;
											if (manjianitem.manjiandetail[j].freeamount>0){
												tmp_amount=parseFloat(manjianitem.manjiandetail[j].freeamount);
											}else if (manjianitem.manjiandetail[j].freediscount<1){
												tmp_amount=(1-parseFloat(manjianitem.manjiandetail[j].freediscount))*parseFloat(detail_sort[chavalue]);
											}else if (manjianitem.manjiandetail[j].newamount!=-1){
												tmp_amount=parseFloat(detail_sort[chavalue])-parseFloat(manjianitem.manjiandetail[j].newamount);
											}
											freeamount=freeamount+tmp_amount;
											manjianindex=j;
										}
									}
								}
						}
						manjianitem.freeamount=freeamount;
						manjianitem.limitamount=limitamount;
						manjianitem.manjianindex=manjianindex;
						manjianamount=manjianamount+freeamount;
					}
				}
			}
			this.selectamount=aamount.toFixed(2);
			this.selectnum=anum;
			this.selectamount=(aamount-manjianamount).toFixed(2);
			this.manjianamount=manjianamount.toFixed(2);
			this.calccheck();
		},
		yingxiaoselect(mjindex,manjianindex,e){
			console.log(mjindex)
			console.log(e)
			var data=this.cartlist
			var item=data[mjindex].detail[manjianindex];
			var yxl=item.yingxiaolist
			for (var i = 0; i < yxl.length; i++) {
				yxl[i].checkstate=1;
				if (e===yxl[i].id){
					yxl[i].checkstate=0;
					item.manjianid=yxl[i].id;
					item.manjianname=yxl[i].name;
					item.manjianlimituse=yxl[i].limituse;
					item.manjianindex="";
					item.manjiandetail=yxl[i].detail;
				}
			}
			item.yingxiaolist=yxl;
			this.setmanjianfromcart(mjindex,manjianindex,item.manjianid);
			data[mjindex].detail[manjianindex]=item;
			var data2=[]
			for (let i in data){
				for(let j in data[i].detail){
					data2.push(data[i].detail[j])
				}
			}
			this.resort(data2);
		},
		favopt(mjindex,index,goodsid){
			var indata={
				flag:1,
				goodsid:goodsid
			}
			this.$wd_request("memfavopt",indata,true)
			.then(()=>{
				if (index>-1){
					this.cartlist[mjindex].detail.splice(index,1)
				}
			})
		},
		deleteselect(){
			console.log("deleteselect");
		},
		deletefromcart(mjindex,index,id){
			this.$wd_request("deletefromcart",{ids:id},true)
			.then(()=>{
				if (index>-1){
					this.cartlist[mjindex].detail.splice(index,1);
				}
			})
		},
		handleSelect(e) {
			console.log(e);
			this.activeIndex = e.toString();
		},
		suggestpage(value) {
			if (value < 0) {
				if (this.pageindex === 0) {
					this.pageindex = Math.ceil(this.hotlist.length / 4) - 1;
				} else {
					this.pageindex--;
				}
			} else {
				if ((this.pageindex + 1) * 4 > this.hotlist.length) {
					this.pageindex = 0;
				} else {
					this.pageindex++;
				}
			}
			this.settemphot();
		},
		favpage(value) {
			if (value < 0) {
				if (this.favpageindex === 0) {
					this.favpageindex = Math.ceil(this.favlist.length / 4) - 1;
				} else {
					this.favpageindex--;
				}
			} else {
				if ((this.favpageindex + 1) * 4 > this.favlist.length) {
					this.favpageindex = 0;
				} else {
					this.favpageindex++;
				}
			}
			this.settemphot();
		},
		historypage(value) {
			if (value < 0) {
				if (this.historypageindex === 0) {
					this.historypageindex = Math.ceil(this.historylist.length / 4) - 1;
				} else {
					this.historypageindex--;
				}
			} else {
				if ((this.historypageindex + 1) * 4 > this.historylist.length) {
					this.historypageindex = 0;
				} else {
					this.historypageindex++;
				}
			}
			this.settemphot();
		},
		settemphot() {
			// if (this.pageindex * 4 > this.hotlist.length) {
			// 	this.pageindex = 0;
			// } else {
			// 	this.pageindex++;
			// }
			var tmp = [];
			var cnt = 0;
			for (var i = this.pageindex * 4; i < this.hotlist.length; i++) {
				cnt++;
				if (cnt < 5) {
					tmp.push(this.hotlist[i]);
				} else {
					break;
				}
			}
			this.temphotlist = tmp;
		},
		settemphistory() {
			var tmp = [];
			var cnt = 0;
			for (var i = this.pageindex * 4; i < this.historylist.length; i++) {
				cnt++;
				if (cnt < 5) {
					tmp.push(this.historylist[i]);
				} else {
					break;
				}
			}
			this.temphistorylist = tmp;
		},
		settempfav() {
			var tmp = [];
			var cnt = 0;
			for (var i = this.pageindex * 4; i < this.favlist.length; i++) {
				cnt++;
				if (cnt < 5) {
					tmp.push(this.favlist[i]);
				} else {
					break;
				}
			}
			this.tempfavlist = tmp;
		},
		loadhot() {
			this.$wd_request('goodslist', { contype: 1 }).then(data => {
				this.hotlist = data.value;
				this.$nextTick(() => {
					this.settemphot();
				});
			});
		},
		loadcart(){
			this.$wd_request("cartlist",{},true).then(data=>{
				this.resort(data.value);
				// this.cartlist=data.value;
				// this.cartnum=this.cartlist.length;
				// this.countall()
				// this.calccheck()
			})
		},
		loadfavlist(){
			this.$wd_request('memfav', {}).then(data => {
				this.favlist = data.value;
				this.$nextTick(() => {
					this.settempfav();
				});
			});
		},
		calccheck(){
			var cnt=0;
			for (var i = 0; i < this.cartlist.length; i++) {
				for (var j=0;j<this.cartlist[i].detail.length;j++){
					if (this.cartlist[i].detail[j].checkstate=="0"){
						cnt++
					}
				}
			}
			this.checknum=cnt;
		},
		setmanjianfromcart(mjindex,index,manjianid){
			let indata={
				id:this.cartlist[mjindex].detail[index].id,
				manjianid:manjianid
			};
			this.$wd_request("setmanjianfromcart",indata)
			.then(()=>{})
			.catch(()=>{})
		},
		oneselect(mjindex,index){
			if (this.cartlist[mjindex].detail[index].deliver==""){
				this.$wd_toast("抱歉，该商品在该地区暂时缺货");
				return;
			}
			if (this.cartlist[mjindex].detail[index].checkstate==0){
				this.cartlist[mjindex].detail[index].checkstate=1;
				this.selectall=false;
			}else{
				this.cartlist[mjindex].detail[index].checkstate=0;
			}
			this.checkstateflag();
			let indata={
				memguid:this.logininfo.myinfo.memguid,
				teammemguid:this.logininfo.teammemguid,
				barcodeid:this.cartlist[mjindex].detail[index].barcodeid,
				skdetailid:this.cartlist[mjindex].detail[index].skdetailid,
				checkstate:this.cartlist[mjindex].detail[index].checkstate,
				stockid:this.cartlist[mjindex].detail[index].stockid,
				imei:this.cartlist[mjindex].detail[index].imei,
				pkgs:this.cartlist[mjindex].detail[index].pkgs
			};
			this.$wd_request("setcheckstate",indata,true)
			.then(()=>{
				
			})
			.catch(()=>{
				
			})
		},
		countall(){
			this.calc_manjian();
			return;
			// let camount=0,cnum=0;
			// for (let index in this.cartlist) {
			// 	if (this.cartlist[index].checkstate==0){
			// 		camount=camount+parseFloat(this.cartlist[index].realamount);
			// 		// *parseFloat(this.cartlist[index].num);//+parseFloat(this.cartlist[index].deliveramount);
			// 		cnum=cnum+parseInt(this.cartlist[index].num);
			// 	}
			// }
			// this.selectamount=camount.toFixed(2);
			// this.selectnum=cnum;
			// this.$store.commit("setcartnum",this.cartlist.length);
		},
		addnum(mjindex,index,num){
			var item=this.cartlist[mjindex].detail[index];
			let nownum=parseInt(item.num);
			if (num<0){
				nownum=nownum+num;
				if (nownum==0){
					nownum=1;
				}
			}else{
				nownum=nownum+num;
				if (nownum>item.pernum){
					this.$wd_toast("数量不能超出：【"+this.$weidajs.numberFixed(item.pernum,0)+"】");
					return;
				}
			}
			let indata={
				barcodeid:item.barcodeid,
				num:nownum,
				skdetailid:item.skdetailid,
				stockid:item.stockid,
				imei:item.imei,
				pkgs:item.pkgs
			};
			this.$wd_request("setnum",indata,this,function(that,data){
				if (data.rs==0){
					that.cartlist[index].num=nownum;
					that.cartlist[index].realamount=(nownum*that.cartlist[index].appprice).toFixed(2);
					if (that.cartlist[index].checkstate!=0){
						that.cartlist[index].checkstate=0;
					}
					that.countall();
				}
			})
		},
		selectallopt(){
			this.selectall=!this.selectall;
			let checkstate=1;
			if (this.selectall){
				checkstate=0;
			}
			for (let index in this.cartlist) {
				if (this.cartlist[index].deliver==""){
					this.cartlist[index].checkstate=checkstate;	
				}else{
					this.cartlist[index].checkstate=checkstate;	
				}
				
			}
			this.countall();
		},
		checkstateflag(){
			let isall=true;
			for (let index in this.cartlist) {
				if (this.cartlist[index].checkstate!=0){
					isall=false;
					break;
				}
			}
			this.selectall=isall;
			this.countall();
		},
		loadhistorylist(){
			this.$wd_request('memhistory', {}).then(data => {
				this.historylist = data.value;
				this.$nextTick(() => {
					this.settemphistory();
				});
			});
		},
		gotogoodsdetail(goodsid, goodsname) {
			this.$router.push({
				name: 'Goodsinfo',
				query: {
					goodsid: goodsid,
					goodsname: goodsname
				}
			});
		},
		gotobuy(){
			if (this.selectnum==0){
				this.$wd_toast("请选择购买商品");
				return;
			}
			//计算总选择数量
			var cnt=0;
			for (var i = 0; i < this.cartlist.length; i++) {
				if (this.cartlist[i].checkstate==0){
					cnt++;
					if (this.cartlist[i].num>this.cartlist[i].pernum){
						this.$wd_toast("【"+this.cartlist[i].name+"】"+"数量不能超出：【"+this.$weidajs.numberFixed(this.cartlist[i].pernum,0)+"】");
						return;
					}
				}	
			}
			if (cnt>100){
				this.$wd_toast("单次下单不能超过100个商品");
				return;
			}
			this.$router.push({name:"Buy",query:{buyflag:1}});
			
		}
	},
	activated() {
		this.loadcart();
	},
	created() {
		this.loadhot();
		this.loadfavlist()
		this.loadhistorylist()
	}
};
</script>

<style lang="scss" scoped>
	::v-deep .el-input-number--mini {
		width: 100px;
	}
.cartlist {
	.empty {
		padding: 20px 80px 20px 80px;
		color: #333;
		.emptyimg {
			width: 562px;
			margin: 0 auto;
			height: 270px;
		}
	}
	.title {
		height: 32px;
		line-height: 32px;
		margin: 0 0 10px;
		padding: 5px 10px;
		background: #f3f3f3;
	}
		.check2{
			cursor: pointer;
		}
		.check {
			width: 50px;
			flex-shrink: 0;
		}
		.goodsname {
			margin: 0 20px;
			.img {
				width: 80px;
				height: 80px;
				border: 1px solid #eeeeee;
				margin-left: 16px;
				.goodsimg {
					width: 80px;
					height: 80px;
				}
			}
			.name {
				text-align: left;
				margin-left: 10px;
			}
		}
		.price {
			width: 150px;
			flex-shrink: 0;
		}
		.num {
			width: 180px;
			flex-shrink: 0;
			margin-left:10px;
		}
		.amount {
			width: 150px;
			flex-shrink: 0;
		}
		.opt {
			width: 150px;
			flex-shrink: 0;
		}
	.detail{
		.goods{
			border-bottom: 1px solid #d5d5d5;
			padding: 22px 0;
		}
		.manjiancss{
			padding: 10px 10px 10px 30px;
			.flag{
				background-color: $wd-theme;
				color: #FFFFFF;
				font-size: 10px;
				padding: 2px 4px;
				border-radius: 2px;
			}
		}
		.yingxiaocss{
			display: flex;
			justify-content: space-between;
			padding: 20px 0;
			.a{
				flex-shrink: 0;
				margin-right: 10px;
				.t{
					border: 1px solid $wd-theme;
					color: $wd-theme;
					padding: 1px 2px;
					border-radius: 2px;
					font-size: 10px;
				}
			}
			.b{
				flex-grow: 1;
				color: #333333;
			}
			.c{
				width: 40px;
				flex-shrink: 0;
			}
		}
	}
}
.loginhint {
	color: #f08500;
	background: #ffebeb;
	height: 46px;
	line-height: 46px;
	padding: 0 35px;
	border: 1px solid #ffdbdb;
}
.suggest {
	height: 275px;
	transition: all 0.5s linear;
	margin-top: 20px;
	position: relative;
	.ul {
		height: 100%;
		width: auto;
		.li {
			width: 25%;
			.goods {
				position: relative;
				padding: 20px;
				background: #fff;
				margin: -1px 0 0 -1px;
				border: 1px dashed #cacaca;
				overflow: hidden;
				cursor: pointer;
				.img {
					width: 160px;
					margin: 0 auto;
					overflow: hidden;
					.goodsimg {
						width: 160px;
						height: 160px;
						border: 0;
					}
				}
				.name {
					height: 36px;
					line-height: 18px;
					margin: 5px 0;
					overflow: hidden;
				}
				.price {
					width: 100%;
					margin: 5px 0 2px;
					overflow: hidden;
					text-align: center;
				}
			}
		}
	}
	.nav {
		position: absolute;
		top: 50%;
		margin-top: -30px;
		z-index: 3;
		display: block;
		width: 40px;
		height: 50px;
		background-color: rgba(0, 0, 0, 0.1);
		color: #999;
		text-align: center;
		font-size: 42px;
		font-weight: 400;
		display: flex;
		align-items: center;
		justify-content: center;
		&.left {
			left: 0;
		}
		&.right {
			right: 0;
		}
		&:hover {
			background: rgba(0, 0, 0, 0.2);
			cursor: pointer;
		}
	}
}
</style>
